import { apiInstance } from "../networking";

export const KydDetailsByKycID = async (kycID,customerType) => {
  const { data = {} } = await apiInstance.get(
    `/util/kycData?kycId=${kycID}&custType=${customerType}`
  );
  return data;
};
